import moment from 'moment';

import { callApi } from '../common/services/baseServices';
import { callApi_file } from '../common/services/attachFile';
import { host } from '../environment';
import { getCookie } from '../common/enum';
import axios from '../axios';

const ACTIONS = {
    GET_DATA_ADMIN_DELIVERY_SUCCESS: 'GET_DATA_ADMIN_DELIVERY_SUCCESS',
    GET_DATA_ADMIN_DELIVERY_ERROR: 'GET_DATA_ADMIN_DELIVERY_ERROR',
    GET_DATA_ADMIN_DELIVERY_WORKSPACE_SUCCESS: 'GET_DATA_ADMIN_DELIVERY_WORKSPACE_SUCCESS',
    GET_DATA_ADMIN_DELIVERY_WORKSPACE_ERROR: 'GET_DATA_ADMIN_DELIVERY_WORKSPACE_ERROR',
    GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_SUCCESS: 'GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_SUCCESS',
    GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ERROR: 'GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ERROR',
    GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_SUCCESS: 'GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_SUCCESS',
    GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_ERROR: 'GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_ERROR',
    DELETE_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_SUCCESS: 'DELETE_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_SUCCESS',
    DELETE_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_ERROR: 'DELETE_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_ERROR',
    ADD_ADMIN_DELIVERY_WORKSPACE_SUCCESS: 'ADD_ADMIN_DELIVERY_WORKSPACE_SUCCESS',
    ADD_ADMIN_DELIVERY_WORKSPACE_ERROR: 'ADD_ADMIN_DELIVERY_WORKSPACE_ERROR',
    GET_LIST_GAMES_SUCCESS: 'GET_LIST_GAMES_SUCCESS',
    GET_LIST_GAMES_ERROR: 'GET_LIST_GAMES_ERROR',
    COPY_WORKSPACE_SUCCESS: 'COPY_WORKSPACE_SUCCESS',
    COPY_WORKSPACE_ERROR: 'COPY_WORKSPACE_ERROR',
    DELETE_TOPICS_SUCCESS: 'DELETE_TOPICS_SUCCESS',
    DELETE_TOPICS_ERROR: 'DELETE_TOPICS_ERROR',
    EDIT_WORKSPACE_SUCCESS: 'EDIT_WORKSPACE_SUCCESS',
    EDIT_WORKSPACE_ERROR: 'EDIT_WORKSPACE_ERROR',
    DELETE_WORKSPACE_SUCCESS: 'DELETE_WORKSPACE_SUCCESS',
    DELETE_WORKSPACE_ERROR: 'DELETE_WORKSPACE_ERROR',
    GET_ALL_TEAM_SUCCESS: 'GET_ALL_TEAM_SUCCESS',
    GET_ALL_TEAM_ERROR: 'GET_ALL_TEAM_ERROR',
    CREATE_TOPIC_SUCCESS: 'CREATE_TOPIC_SUCCESS',
    CREATE_TOPIC_ERROR: 'CREATE_TOPIC_ERROR',
    GET_LIST_PLAYER_TOPIC_SUCCESS: 'GET_LIST_PLAYER_TOPIC_SUCCESS',
    GET_LIST_PLAYER_TOPIC_ERROR: 'GET_LIST_PLAYER_TOPIC_ERROR',
    GET_CUSTOMERS_SUCCESS: 'GET_CUSTOMERS_SUCCESS',
    GET_CUSTOMERS_ERROR: 'GET_CUSTOMERS_ERROR',
    ADD_WS_GET_CUSTOMERS_SUCCESS: 'ADD_WS_GET_CUSTOMERS_SUCCESS',
    ADD_WS_GET_CUSTOMERS_ERROR: 'ADD_WS_GET_CUSTOMERS_ERROR',
    OPEN_TOPIC_WORKSPACE_SUCCESS: 'OPEN_TOPIC_WORKSPACE_SUCCESS',
    OPEN_TOPIC_WORKSPACE_ERROR: 'OPEN_TOPIC_WORKSPACE_ERROR',
    ADD_ADMIN_DELIVERY_WORKSPACE_FILES_SUCCESS: 'ADD_ADMIN_DELIVERY_WORKSPACE_FILES_SUCCESS',
    ADD_ADMIN_DELIVERY_WORKSPACE_FILES_ERROR: 'ADD_ADMIN_DELIVERY_WORKSPACE_FILES_ERROR'
};

const updateStatus = (type, data, payload) => ({
    type,
    data,
    payload
});

const getAdminDelivery = (data) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    let url = `${host.serverTest}api/admin/deliveries/workspaces?page=${data.page}&keyword=${data.keyword}`;

    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_ADMIN_DELIVERY_SUCCESS, data));
            }, (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_ADMIN_DELIVERY_ERROR, err));
            });
    };
}

const getTopicWorkSpace = (idWorkSpace) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/deliveries/workspaces/${idWorkSpace}/topics?sort=${''}&order=${''}`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_ERROR, err));
            });
    };
}

const getFilesWorkSpaceAdmin = (idWorkSpace) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/deliveries/workspaces/${idWorkSpace}/files`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ERROR, err));
            });
    };
}

const getFilesIdWorkSpaceAdmin = (idWorkSpace, idFile) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'text/plain',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi_file(`${host.serverTest}api/admin/deliveries/workspaces/${idWorkSpace}/files/${idFile}`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_ERROR, err));
                console.log(err);
            });
    };
}

const deleteFilesIdWorkSpaceAdmin = (idWorkSpace, idFile) => {
    const config = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/deliveries/workspaces/${idWorkSpace}/files/${idFile}`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.DELETE_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.DELETE_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_ERROR, err));
            });
    };
}

const postFilesWorkSpaceAdmin = (idWorkSpace) => {

    const fd = new FormData();
    const input_file = document.querySelector('input[id=file_upload]');
    fd.append('file', input_file.files[0]);

    const config = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`
        },
        body: fd
    };

    return (dispatch) => {
        callApi_file(`${host.serverTest}api/admin/deliveries/workspaces/${idWorkSpace}/files`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.ADD_ADMIN_DELIVERY_WORKSPACE_FILES_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.ADD_ADMIN_DELIVERY_WORKSPACE_FILES_ERROR, err));
            });
    };
}

const getListGames = (date) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    const dataReturn = moment(new Date(date ? date : '')).format('MM/DD/YYYY');
    return (dispatch) => {
        callApi(`${host.serverTest}api/masters/games?current_date=${moment(new Date(date ? date : '')).format('YYYY/MM/DD')}`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_LIST_GAMES_SUCCESS, data, dataReturn));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_LIST_GAMES_ERROR, err));
            });
    };
}

const addWorkspace = (data) => {
    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify(data)
    };
    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/deliveries/workspaces`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.ADD_ADMIN_DELIVERY_WORKSPACE_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.ADD_ADMIN_DELIVERY_WORKSPACE_ERROR, err));
            });
    };
}

const copyWorkSpace = (topic_id, wpId) => {
    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify({ workspace_id: wpId })
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/topics/${topic_id}/copy`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.COPY_WORKSPACE_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.COPY_WORKSPACE_ERROR, err));
            });
    };
}

const deleteTopics = (topic_id) => {
    const config = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        }
    };
    const dataResponse = { message: 'success' };
    return (dispatch) => {
        callApi(`${host.serverTest}api/topics/${topic_id}`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.DELETE_TOPICS_SUCCESS, dataResponse))
                if (data.error) {
                    dispatch(updateStatus(ACTIONS.DELETE_TOPICS_ERROR, data.error))
                }
            }, () => {
                dispatch(updateStatus(ACTIONS.DELETE_TOPICS_SUCCESS, { message: "success" }))
            });
    };
}

const editWorkSpace = (workspace_id, data) => {
    const config = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify(data)
    };
    const dataResponse = { message: 'success' };
    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/deliveries/workspaces/${workspace_id}`, config,
            dispatch(updateStatus(ACTIONS.EDIT_WORKSPACE_SUCCESS, dataResponse)),
            (err) => {
                dispatch(updateStatus(ACTIONS.EDIT_WORKSPACE_ERROR, err));
            });
    };
}

const openTopics = (listTopic, workspace_id) => {
    const config = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify(listTopic)
    };
    const dataResponse = { message: 'success' };
    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/deliveries/workspaces/${workspace_id}/opened`, config,
            dispatch(updateStatus(ACTIONS.OPEN_TOPIC_WORKSPACE_SUCCESS, dataResponse)),
            (err) => {
                dispatch(updateStatus(ACTIONS.OPEN_TOPIC_WORKSPACE_ERROR, err));
            });
    };
}

const deleteWorkSpace = (workspace_id) => {
    return () => {
        return axios.delete(`api/admin/deliveries/workspaces/${workspace_id}`);
    };
}

const getAllTeamAdmin = () => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/masters/teams`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_ALL_TEAM_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_ALL_TEAM_ERROR, err));
            });
    };
}

const createTopics = (data) => {
    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify(data)
    };
    return (dispatch) => {
        callApi(`${host.serverTest}api/topics`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.CREATE_TOPIC_SUCCESS, data));
            }, (err) => {
                dispatch(updateStatus(ACTIONS.CREATE_TOPIC_ERROR, err));
            });
    };
}

const getListPlayersTopic = (keyword) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/masters/players?keyword=${keyword || ''}`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_LIST_PLAYER_TOPIC_SUCCESS, data));
            }, (err) => {
                dispatch(updateStatus(ACTIONS.GET_LIST_PLAYER_TOPIC_ERROR, err));
            });
    };
}

const getListCustomers = (keyword) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/customers?keyword=${keyword}`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_CUSTOMERS_SUCCESS, data));
            }, (err) => {
                dispatch(updateStatus(ACTIONS.GET_CUSTOMERS_ERROR, err));
            });
    };
}

const getListFromAddWorkspace = (keyword) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/customers?keyword=${keyword}`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.ADD_WS_GET_CUSTOMERS_SUCCESS, data));
            }, (err) => {
                dispatch(updateStatus(ACTIONS.ADD_WS_GET_CUSTOMERS_ERROR, err));
            });
    };
}


// // get list company
// const listCompany = () => {
//     const config = {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
//         },
//     };

//     return (dispatch) => {
//         callApi(`${host.serverTest}api/admin/customers/companies`,
//             config,
//             (data) => {
//                 dispatch(updateStatus(ACTIONS.GET_COMPANY_SUCCESS, data));
//             },
//             (err) => {
//                 dispatch(updateStatus(ACTIONS.GET_COMPANY_ERROR, err));
//             });
//     };
// }

export {
    ACTIONS, getAdminDelivery, getTopicWorkSpace, getFilesWorkSpaceAdmin, getFilesIdWorkSpaceAdmin, deleteFilesIdWorkSpaceAdmin, postFilesWorkSpaceAdmin, addWorkspace, getListGames,
    copyWorkSpace, deleteTopics, editWorkSpace, deleteWorkSpace, getAllTeamAdmin,
    createTopics, getListPlayersTopic, getListCustomers, openTopics, getListFromAddWorkspace
};
